import utils from "@src/common/utils";
import store from "@src/common/lib/store";
import i18n from "@src/common/lib/i18n";
import { formatTimeToStr } from "../filter/dateUtils";
import { Dic, Cache } from "$utils";
const tableOption = function (that) {
  let select = [];
  // $.ajax({
  //   type:'post',
  //   headers: {
  //     'ticket': store.getters.userInfo.access_token || '',
  //     'locale': i18n.locale || ''
  //   },
  //   url:'/bas/emergency/queryAlarmTypeList.json',
  //   data:JSON.stringify({"parkId":"200000001"}),
  //   dataType: "json",
  //   contentType: 'application/json',
  //   async:false,
  //   success:(data)=>{
  //     data.returnObj.map((val)=>{
  //       select.push({
  //         label:val.name,
  //         value:val.alarmType
  //       })
  //     })
  //   },
  //   error:(error)=>{
  //   }
  // })
  return {
    page: true,
    selection: false,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    // calcHeight: 100,
    menuWidth: 200,
    index: true,
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: "955px",
    emptyText: "暂无数据",
    column: [
      {
        label: "预案名称",
        prop: "emergencyPlanName",
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        search: true,
        hide: false,
        overHidden: true,
        clearable: true,
        align: "center",
        searchPlaceholder: "请输入预案名称",
        minRows: 4,
        maxlength: 50,
        span: 12,
        rules: [
          { required: true, message: "请输入预案名称", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: "blur" }
        ]
      },
      {
        label: "预案分类",
        type: "select",
        prop: "subSystem",
        search: false,
        dicData: Dic.find("SENU073005"),
        formatter: function (row, value) {
          return Dic.findByValue("SENU073005", value);
        },
        span: 12
      },
      {
        label: "预案状态",
        type: "select",
        prop: "status",
        hide: false,
        search: true,
        dicData: [
          { label: "未启动", value: 1 },
          { label: "执行中", value: 2 },
          { label: "已完成", value: 3 }
        ],
        formatter: function (row, value) {
          let str = "";
          if (value == 1) {
            str = "未启动";
          }
          if (value == 2) {
            str = "执行中";
          }
          if (value == 3) {
            str = "已完成";
          }
          return str;
        },
        span: 12
      },
      {
        label: "执行人",
        prop: "activor",
        search: false,
        span: 12
      },
      {
        label: "启用时间",
        prop: "activeTime",
        search: false,
        formatter: function (row, value) {
          let time = "";
          if (value) {
            time = formatTimeToStr(value, "yyyy-MM-dd hh:mm:ss");
          }
          return time;
        },
        span: 12
      }
    ]
  };
};
export default tableOption;
